import { Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/EmptyState";

export function NotFoundPage() {
  return (
    <section className="px-6 py-5 max-w-[1280px] w-full mx-auto">
      <EmptyState
        icon="FileQuestionMark"
        title="There is nothing at this address"
        description="The page may have moved, or the link is out of date."
        action={
          <Link to="/" className="text-sm text-primary font-medium">
            Back to overview
          </Link>
        }
      />
    </section>
  );
}
